import React from "react";
import { differentiators } from "../data/landing";
import { MobileAccordion } from "./MobileAccordion";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function Differentiation() {
  return <section aria-labelledby="diferentes" className="section-pad border-b border-line" data-id="element-152" data-mp="1anfnptlblgmv">
      <div className="page-container" data-id="element-153" data-mp="1fh0b6rpaes7t">
        <Reveal data-id="element-154" data-mp="1jh2f77ihvxq9">
          <SectionHeader number="06" label="No somos una agencia tradicional" titleId="diferentes" title={<>
                No venimos a venderte humo.{" "}
                <span className="text-gold" data-id="element-156" data-mp="1tgjk3mpxa7l6">Venimos a cerrar la fuga entre el lead y la venta.</span>
              </>} data-id="element-155" data-mp="1jhk93xhopzv0" />
        </Reveal>

        <Reveal className="mt-10 border-y border-line py-10 md:mt-12 md:py-10 lg:py-12" data-id="element-157" data-mp="3v6uycyye5kee">
          <blockquote className="balance font-display text-[30px] uppercase leading-[1.05] tracking-[-0.01em] text-cream sm:text-[40px] md:text-[52px] lg:text-[60px]" data-id="element-158" data-mp="40adjwyxj8pt">
            “El sistema es automático. <span className="text-gold" data-id="element-159" data-mp="1bip9ivmiezn7">El criterio no.</span>”
          </blockquote>
        </Reveal>

        <MobileAccordion className="border-t-0" defaultOpen={null} items={[{
        id: "diferencias",
        title: "Ver los 5 puntos",
        content: <ul className="space-y-3" data-id="element-161" data-mp="1ug9ys3t6s08c">
                  {differentiators.map(text => <li key={text} className="flex gap-3" data-id="element-162" data-mp="1pg5mkpzb9rnx">
                      <span className="font-ui font-bold text-gold" aria-hidden="true" data-id="element-163" data-mp="1peks10czy8q2">
                        →
                      </span>
                      <span className="text-[16px] leading-snug text-cream" data-id="element-164" data-mp="1ggqvbobbld2d">{text}</span>
                    </li>)}
                </ul>
      }]} data-id="element-160" data-mp="11r2t8kvbeadl" />

        <ul className="hidden gap-x-10 md:grid md:grid-cols-2" data-id="element-165" data-mp="50kci1fbg1u6">
          {differentiators.map((text, i) => <li key={text} className="border-b border-line py-5" data-id="element-166" data-mp="6j0sl8h4ss09" data-mpi={i}>
              <Reveal delay={i * STAGGER} className="flex gap-3" data-id="element-167" data-mp="bgslo5tiik61">
                <span className="font-ui font-bold text-gold" aria-hidden="true" data-id="element-168" data-mp="beznzg0vnaa6">
                  →
                </span>
                <p className="font-ui text-[17px] font-bold leading-snug text-cream" data-id="element-169" data-mp="1imlptr9no3t">{text}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}